import { useEffect, useState } from "react";

export interface GridSearchBoxProps {
  onSearch: (value: string) => void;
  placeholder?: string;
  /** Debounce delay in ms before onSearch fires. */
  delay?: number;
  className?: string;
}

/**
 * Debounced free-text search input for grid pages. Pair it with
 * createODataSearchFilters to turn the emitted text into an OData $filter.
 */
export const GridSearchBox = ({ onSearch, placeholder = "Search...", delay = 400, className }: GridSearchBoxProps) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    const handle = setTimeout(() => onSearch(value.trim()), delay);
    return () => clearTimeout(handle);
  }, [value, delay, onSearch]);

  return (
    <div className={`position-relative ${className ?? ""}`}>
      <i
        className="fa fa-search text-muted position-absolute"
        style={{ left: 12, top: "50%", transform: "translateY(-50%)" }}
      />
      <input
        type="search"
        className="form-control"
        style={{ minWidth: 240, paddingLeft: 34 }}
        placeholder={placeholder}
        aria-label={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </div>
  );
};

export default GridSearchBox;
